import styled, { css } from "styled-components";
import { Button } from "../../../../../../components/Button";
import { EC_COMBINEDLIST, EC_DEFAULT, EC_QUESTIONLIST, EC_SENDMODALCOMBINATION, EC_STEPTHREELIST, EC_SURVEYLIST, EC_STEPTHREECOMBINEDALTERNATIVES, EC_STEPTHREESEPARATEALTERNATIVES } from "./renderTypes";
import { combinedListMode, questionListMode, sendModalCombination, stepThreeCombinedAlternatives, stepThreeList, stepThreeSeparateAlternatives, surveyListMode } from "./stylesMode";

const renderStyleMode = {
  [EC_SURVEYLIST]: surveyListMode,
  [EC_QUESTIONLIST]: questionListMode,
  [EC_COMBINEDLIST]: combinedListMode,
  [EC_SENDMODALCOMBINATION]: sendModalCombination,
  [EC_STEPTHREELIST]: stepThreeList,
  [EC_STEPTHREECOMBINEDALTERNATIVES]: stepThreeCombinedAlternatives,
  [EC_STEPTHREESEPARATEALTERNATIVES]: stepThreeSeparateAlternatives,
  [EC_DEFAULT]: () => "",
};

export const GenericContainer = styled.section`
  display: flex;
  gap: 4px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  padding: 8px 0 8px 18px;
  transition: border-color 0.2s;
  ${({ zIndex }) =>
    zIndex
      ? css`
          z-index: ${zIndex};
        `
      : ""};

  width: ${({ width }) => width || "100%"};
  min-height: ${({ minHeight }) => minHeight || "74px"};
  max-height: ${({ maxHeight }) => maxHeight || "auto"};

  .label {
    width: fit-content;
    padding: 3px 11px;
    display: flex;
    gap: 10px;
    align-items: center;

    font-weight: ${props => props.renderStyle === 'stepThreeList' ? 700 : 400};
    font-size: 8px;
    border-radius: 4px;
    
    border: 1px solid
      ${(props) =>
        props.isChecked
          ? props.theme.colors.text.default
          : props.theme.colors.lightGray};
    color: ${(props) =>
      props.isChecked
        ? props.theme.colors.text.default
        : props.theme.colors.text.placeholder};

    svg {
      width: 16px;
    }

    svg path {
      stroke: ${props => props.theme.colors.iconEvolutiveColor};
    }

    span {
      font-size: 12px;
    }
  }

  ${(props) =>
    props.isChecked
      ? css`
          background-color: ${props.theme.colors
          .backgroundItemColor} !important;
        `
      : ""}
  background-color: ${(props) => props.theme.colors.component};

  border: 1px solid ${(props) => props.theme.colors.details};
  border-radius: 4px;

  &:hover {
    border: 1px solid ${(props) => props.theme.colors.secondary};
    background-color: ${(props) =>
    props.isChecked
      ? props.theme.colors.backgroundItemColor
      : props.theme.colors.highLight};

    > .checkbox {
      border: 1px solid ${(props) => props.theme.colors.secondary};
    }

    .svgThickArrow {
      fill: ${(props) => props.theme.colors.secondary};
    }

    .svgThickArrow path {
      fill: ${(props) => props.theme.colors.secondary};
    }
  }
  ${(props) => renderStyleMode[props.renderStyle](props)}
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .select {
    display: flex;
    width: 52px;
    height: 56px;
    align-items: center;
    justify-content: center;
    border-left: 1px solid
      ${(props) => props.theme.colors.cardContainerEvolutiveCross};
    cursor: pointer;

    svg {
      transform: rotate(${(props) => (props.openAlternatives ? "180deg" : 0)});
      transition: all 0.2s;
      width: 15.4px;
      height: 10.01px;
      fill: ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
    }

    svg path {
      fill: ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
    }
  }

  .titles {
    margin-left: 18px;
    gap: 6px;
    flex-direction: column;
    display: flex;
    width: calc(100% - 92px);
    padding-right: 18px;
  }
`;

export const SeletableArea = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  align-items: center;

  :hover {
    cursor: ${({selectable}) => selectable ? "pointer" : "default"};
  }
`;

export const QuestionWrapper = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;

  h2 {
    align-items: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 0;
    color: ${(props) => props.theme.colors.titleItemColor};
    padding-top: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    b.green {
      color: ${(props) => props.theme.colors.secondary};
    }
  }
`;

export const Alternatives = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-right: 18px;
  height: ${(props) => (props.openAlternatives ? "auto" : 0)};
  transform: scaleY(${(props) => (props.openAlternatives ? "1" : 0)});
  transform-origin: top;
  transition: all 0.2s ease-out;

  z-index: 9999;

  ${({ childrenDisplayMode }) =>
    childrenDisplayMode === "overflow"
      ? css`
      overflow: unset;

      & .collapsibleBody {
        position: absolute;
        left: 0;
        top: 100%:
      }
          
    `
      : ""};

  > .collapsibleBody {
    margin-top: 9px;
    border-top: 1px solid
      ${(props) =>
        props.openAlternatives
          ? props.theme.colors.text.placeholder
          : "transparent"};
    padding: 8.33px 0;
    display: flex;
    align-items: center;

    svg {
      width: 16.67px;
      height: 16.67px;
      margin-bottom: 2px;
      fill: ${(props) =>
        props.isChecked
          ? props.theme.colors.text.default
          : props.theme.colors.text.placeholder};
    }

    svg path {
      fill: ${(props) =>
    props.isChecked
      ? props.theme.colors.text.default
      : props.theme.colors.text.placeholder};
    }

    h3 {
      color: ${(props) =>
    props.isChecked
      ? props.theme.colors.text.default
      : props.theme.colors.text.placeholder};
      margin: 0;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
    }
  }
`;

export const CheckboxWrapper = styled.span`
  ${({ disabled }) => disabled ? css`
    cursor: not-allowed;
  ` : ''}
`;

export const CheckboxButton = styled(Button)`
  cursor: pointer;

  ${({ disabled }) => disabled ? css`
    pointer-events: none;
  ` : ''}

  padding: 5px 0px;
  height: 20px;
  width: 20px;
  margin-right: 2px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
    color: transparent;
  }

  ${(props) => ({
    display: props.isBolded ? "none" : "",
  })}
`;

export const Square = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 2.28571px;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.secondary
      : props.theme.colors.text.default};
  display: inline-block;
  background: transparent;
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 6px;
    width: 1.45px;
    background: ${props.theme.colors.secondary};
  }

  :after {
    transform: rotate(45deg);
    left: 5.7px;
    top: 2.5px;
  }
  :before {
    height: 2px;
    transform: rotate(-45deg);
    left: 3px;
    top: 4.8px;
  }
  `
      : ""}
`;

export const Circle = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 10px;
  border: 1px solid
    ${(props) =>
    props.isChecked
      ? props.theme.colors.text.default
      : props.theme.colors.secondary};
  display: inline-block;
  background: none;
  box-sizing: border-box;
  padding: 1px;

  :after {
    content: "";
    display: block;
    border-radius: 12px;
    width: 3.5px;
    height: 3.5px;
    margin: 1px auto 0 auto;

    background: ${(props) =>
    props.isChecked ? props.theme.colors.text.default : "transparent"};
  }
`;

export const RemoveWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  min-width: 40px;
  cursor: pointer;
  border: 1px solid ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  border-radius: 4px;
  max-height: ${({ maxHeight }) => maxHeight || "54px"};
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: '×';
    color: ${(props) => props.theme.colors.text.default};
    font-size: 2.5rem;
    font-family: inherit;
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.EvolutivevOkButtonColor};
    border: 1px solid ${(props) => props.theme.colors.secondary};

    &::after {
      color: ${(props) => props.theme.colors.secondary};
    }
  }

  &:active {
    background-color: ${(props) => props.theme.colors.secondary};

    &::after {
      color: ${(props) => props.theme.colors.text.default};
    }
  }
`

export const Tags = styled.div`
  display: ${({withTag}) => withTag ? "flex" : "none"};
  align-items: center;
  gap: 8px;
`;

export const Visualized = styled.div`
  .label {
    border: 1px solid ${props => props.isOpen && props.theme.colors.secondary};
    svg path {
      stroke: none;
      fill: ${props => props.isOpen ? props.theme.colors.secondary : props.theme.colors.iconEvolutiveColor};
    }
    span {
      color: ${props => props.isOpen && props.theme.colors.secondary};
      text-transform: uppercase;
    }
  }
`